import { routine, ofType, dispatchAction, withNamespace } from '@ardoq/rxbeach';
import { map, tap, withLatestFrom } from 'rxjs';
import {
  setFormattingOptions,
  setFormattingRules,
  setMigratedFormattingRules,
} from './viewpointBuilderFormattingActions';
import { migrateRules } from '@ardoq/perspectives';
import { Observable } from 'rxjs';
import { ViewpointFormattingState } from './viewpointFormattingTypes';

export const getMigrateFormattingRulesRoutine = (
  viewpointFormattingState$: Observable<ViewpointFormattingState>,
  namespace: string
) =>
  routine(
    withNamespace(namespace),
    ofType(setFormattingRules, setFormattingOptions),
    withLatestFrom(viewpointFormattingState$),
    map(([, viewpointFormattingState]) => {
      const {
        formattingTab: { conditionalFormattingRules },
        viewpointBuilderFormattingOptions: {
          availableComponentFields,
          availableReferenceFields,
          componentTypeNames,
          referenceTypeNames,
        },
      } = viewpointFormattingState;

      return migrateRules({
        rules: conditionalFormattingRules,
        relatedComponentFields: availableComponentFields,
        relatedReferenceFields: availableReferenceFields,
        componentTypeNames,
        referenceTypeNames,
      });
    }),
    tap(({ migratedRules }) => {
      dispatchAction(setMigratedFormattingRules(migratedRules), namespace);
    })
  );
